import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { type ClassCountTuitionBilling } from '~entities/payment/api/class-count-tuition/get-class-count-tuition-billing';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CreateClassCountTuitionBillingInput {
  name: string;
  ranges: Array<{
    minClasses: number;
    maxClasses: number;
    flatRate: number;
  }>;
}

export const createClassCountTuitionBilling = async (
  params: CreateClassCountTuitionBillingInput,
) => {
  const response = await baseAPI.post<ClassCountTuitionBilling>(
    'class-count-tuition-billing',
    params,
  );
  return response.data;
};

export const useCreateClassCountTuitionBilling = () => {
  return useMutation({
    mutationFn: createClassCountTuitionBilling,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASS_COUNT_TUITION_BILLING],
      });
    },
  });
};
